module.exports = __webpack_public_path__ + "img/qrCode.01cbbd34.png";